import { Trans } from 'react-i18next'

export type SubtitleProps = {
  text: string
}

export default function Subtitle({ text }: SubtitleProps) {
  const hasName = text.includes('<name>')

  return (
    <div
      data-testid='subtitle'
      className={`min-h-32 ${
        hasName ? 'pl-4 pr-8' : 'px-8'
      } py-3 flex gap-8 bg-secondary rounded-8 items-baseline text-body`}
    >
      <Trans
        components={{
          name: <div className='rounded-4 min-h-24 px-8 bg-accent1 flex items-center leading-none font-semibold' />,
          em: <em />,
        }}
      >
        {text}
      </Trans>
    </div>
  )
}
